import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { aplicarVariables } from '../theme/theme';

/**
 * EL MODO DE LECTURA — oscuro o claro, a eleccion del lector.
 *
 * Son textos de doce o trece parrafos: mucha gente los lee de noche y mucha
 * otra prefiere fondo claro. La eleccion se guarda en su navegador.
 * Por defecto, oscuro: es lo que sostiene mejor el logo y la marca.
 */

const CLAVE = 'jeshua_modo';
const CLAVE_ALINEACION = 'jeshua_alineacion';

/** Las tres formas de alinear el texto de una canalizacion. */
export const ALINEACIONES = {
  'justificado-guion': 'Justificado, partiendo palabras',
  'justificado':       'Justificado, sin partir palabras',
  'izquierda':         'Alineado a la izquierda'
};
const ModoContexto = createContext({ modo: 'oscuro', alternar: () => {} });

/**
 * El tamano de letra vive aqui, con el modo y la alineacion: las tres son la
 * misma cosa —como quiere leer esta persona— y las tres deben viajar juntas el
 * dia que se guarden en su cuenta. Estaba suelto en la ficha, y una prueba lo
 * cazó: cada archivo que guarda por su cuenta es una frontera mas que vigilar.
 */
export const TAM_MIN = 0.95;
export const TAM_MAX = 1.5;
const CLAVE_TAM = 'jeshua_tam_letra';

export const ProveedorModo = ({ children }) => {
  const [modo, setModo] = useState(() => {
    try {
      const guardado = window.localStorage.getItem(CLAVE);
      if (guardado === 'claro' || guardado === 'oscuro') return guardado;
    } catch (e) { /* navegador sin almacenamiento: seguimos con el valor por defecto */ }
    return 'oscuro';
  });

  const [alineacion, setAlineacion] = useState(() => {
    try {
      const g = window.localStorage.getItem(CLAVE_ALINEACION);
      if (g && ALINEACIONES[g]) return g;
    } catch (e) { /* sin almacenamiento */ }
    return 'justificado';  // decision de Faina, 25-ago: justificado sin cortar palabras
  });

  const [tam, setTam] = useState(() => {
    try {
      const g = parseFloat(window.localStorage.getItem(CLAVE_TAM));
      if (Number.isFinite(g)) return Math.min(TAM_MAX, Math.max(TAM_MIN, g));
    } catch (e) { /* sin almacenamiento */ }
    return 1.1;
  });

  useEffect(() => {
    try { window.localStorage.setItem(CLAVE_TAM, String(tam)); } catch (e) { /* sin almacenamiento */ }
  }, [tam]);

  useEffect(() => {
    aplicarVariables(modo);
    try { window.localStorage.setItem(CLAVE, modo); } catch (e) { /* sin almacenamiento */ }
  }, [modo]);

  useEffect(() => {
    try { window.localStorage.setItem(CLAVE_ALINEACION, alineacion); } catch (e) { /* sin almacenamiento */ }
  }, [alineacion]);

  const valor = useMemo(() => ({
    modo,
    esOscuro: modo === 'oscuro',
    alternar: () => setModo((m) => (m === 'oscuro' ? 'claro' : 'oscuro')),
    fijar: setModo,
    alineacion,
    fijarAlineacion: setAlineacion,
    tam,
    agrandar: () => setTam((t) => Math.min(TAM_MAX, +(t + 0.08).toFixed(2))),
    achicar: () => setTam((t) => Math.max(TAM_MIN, +(t - 0.08).toFixed(2)))
  }), [modo, alineacion, tam]);

  return <ModoContexto.Provider value={valor}>{children}</ModoContexto.Provider>;
};

export const useModo = () => useContext(ModoContexto);
